export default __webpack_public_path__ + "static/media/logo_higher_resolution.71cc3393.png";